import React from 'react';
import { macTheme, BrandContext, EBrand } from '@elc/common';
import { ThemeProvider } from 'styled-components';
import Routes from './routes/routes';
import { Metatags } from './components/Metatags/Metatags';
import './App.css';

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const App: React.FC = () => (
  <ThemeProvider theme={macTheme}>
    <BrandContext.Provider value={EBrand.Mac}>
      <Metatags />
      <Routes />
    </BrandContext.Provider>
  </ThemeProvider>
);

export default App;
